'use strict';

import $ from 'jquery';
import './autoComplete';
import './modal';
import { lib } from '../../common/Library';

/**
 * PC共通
 */
// 戻るボタンで遷移したときオーバーレイ非表示
$(window).on('pageshow', function () {
    $('.loading_overlay').remove();
});

$(function () {
    // ページトップスクロールボタン
    $('.btn_ptop .button').on('click', function () {
        // スクロール
        $('html, body').animate({ scrollTop: 0 }, 300, 'swing');
    });

    // 検索時ボタン:ローディングオーバーレイ表示
    $('#side_find_box, #top_find_box').on('submit', function (event) {
        event.preventDefault(); // デフォルトのイベント動作をキャンセル
        lib.showLoadingOverlay();
        this.submit();
    });

    // 検索時ボタン:ローディングオーバーレイ表示
    $('#header_find_box').on('submit', function (event) {
        let form = this;

        event.preventDefault(); // デフォルトのイベント動作をキャンセル
        lib.checkAndConfirmComparisonEditing(function () {
            lib.showLoadingOverlay();
            form.submit();
        });
    });
});

/**
 * タブ切り替え処理
 */
$(document).on('click', '.tab_select:not(.disable) li:not(.disable)', function () {
    //親要素
    let $tabGroup = $(this).closest('.tab_group'),
        //何番目の要素がクリックされたか取得
        clickIdx = $(this).index(),
        tabSwitchingList = $tabGroup.find('.tab_switching');

    if (tabSwitchingList.length === 0) {
        return;
    }

    $tabGroup.find('.tab_select li').removeClass('active');
    $(this).addClass('active');

    $(tabSwitchingList).removeClass('show');
    $(tabSwitchingList[clickIdx]).addClass('show');
});

/**
 * サブタブ切り替え処理
 */
$(document).on('click', '.sub_tab li', function () {
    //親要素
    let $tabGroup = $(this).closest('.tab_group'),
        //何番目の要素がクリックされたか取得
        clickIdx = $(this).index(),
        subTabSwitchingList = $tabGroup.find('.sub_tab_switching');

    if (subTabSwitchingList.length === 0) {
        return;
    }

    $tabGroup.find('.sub_tab li').removeClass('active');
    $(this).addClass('active');

    $(subTabSwitchingList).removeClass('show');
    $(subTabSwitchingList[clickIdx]).addClass('show');
});

/**
 * 銘柄個別「前画面に戻る」ボタン向けURL保存
 */
$(function () {
    // 現在のページのURLを取得
    const currentPage = window.location.href;

    if (currentPage.includes('/favorite')
        || currentPage.includes('/comparison')
    ) {
        // お気に入り・銘柄比較
        //  戻り先ページとしてセッションにURLを保存
        sessionStorage.setItem('previousUrl', currentPage);
    } else if (currentPage.includes('/symbolDetail/')) {
        // 銘柄個別
        //  なにもしない(個別銘柄のタブ移動は戻り先ページを引き継ぐ)
    } else {
        // セッションからURLを削除
        sessionStorage.removeItem('previousUrl');
    }
});

/**
 * 銘柄個別「前銘柄」「次銘柄」ボタン向け銘柄リスト保存
 */
$(function () {
    // 現在のページのURLを取得
    const currentPage = window.location.href;

    if (currentPage.includes('/favorite')
        || currentPage.includes('/comparison')
    ) {
        // お気に入り・銘柄比較
        //  表示中銘柄リストをセッションに保存
        const shareClassIdJsonList = $('#shareclassid_json_list').val() ?? JSON.stringify([]);
        sessionStorage.setItem('shareClassIdJsonList', shareClassIdJsonList);
    } else if (currentPage.includes('/symbolDetail/')) {
        // 銘柄個別
        //  なにもしない(個別銘柄のタブ移動はリストを引き継ぐ)
    } else {
        // セッションからリストを削除
        sessionStorage.removeItem('shareClassIdJsonList');
    }
});

/**
 * 銘柄個別「前銘柄」「次銘柄」ボタン向け チャートで選択された足種・期間を保存
 */
$(function() {
    // 現在のページのURLを取得
    const currentPage = window.location.href

    if (!currentPage.includes('/symbolDetail/')) {
        // セッションから足種・期間を削除
        sessionStorage.removeItem('range_select');
        sessionStorage.removeItem('period_select');
    }

    $('.period').on('change', function () {
        //足種変更時に足種・期間条件をセッションに保存
        const periodVal = $('.period').val();
        sessionStorage.setItem('period_select', periodVal);
        if ($('.range_weekly').css('display') === 'block') {
            sessionStorage.setItem('range_select', $('.range_weekly').val());
        }
        else if ($('.range_monthly').css('display') === 'block') {
            sessionStorage.setItem('range_select', $('.range_monthly').val());
        }
        else {
            sessionStorage.setItem('range_select', $('.range_daily').val());
        }
    });

    $('.range select').on('change', function () {
        //期間変更時に足種・期間条件をセッションに保存
        const periodVal = $('.period').val();
        const rangeVal = $(this).val();
        sessionStorage.setItem('period_select', periodVal);
        sessionStorage.setItem('range_select', rangeVal);
    });
});

/**
 * 銘柄個別「前銘柄」「次銘柄」ボタン向け チャートで選択された足種・期間を引き継ぎ
 */

$(function() {
    if ('range_select' in sessionStorage ||'period_select' in sessionStorage) {
        //チャートの期間で選択した期間と足種を引き継ぎ
        const periodSelect = sessionStorage.getItem('period_select');
        const rangeSelect = sessionStorage.getItem('range_select');
        $('.period').val(periodSelect);

        if(['5', '6', '7'].includes(rangeSelect)) {
            $('.range_weekly').val(rangeSelect).show();
        } else if(['8'].includes(rangeSelect)) {
            $('.range_monthly').val(rangeSelect).show();
        } else {
            $('.range_daily').val(rangeSelect).show();
        }
    }
});